<template>
    <div style="width: 100%;">
       <!-- <Basicform ref="basicform" :title="formTitle" :module-code="moduleInfo.moduleCode"
            :win-width="moduleInfo.winWidth" :win-height="moduleInfo.winHeight" :toolbar-btns="busiformBtns"
            :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened"
            :on-basic-form-before-submit="onBasicFormBeforeSubmit" :on-basic-form-submited="onBasicFormSubmited">
            <template v-slot:default="slotProps">
                <busi-form ref="busiform" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
            </template>
        </Basicform> -->

        <inner-table id="innerTableMembers" ref="familyMembersList" :listviewurl="'teacher.familyMembers.list'" :can-edit="1" :can-delete="1" :link-prop-name="''" />

        <!-- <inner-table id="innerTableMembers" ref="familyMembersList" :listviewurl="'teacher.familyMembers.list?urlsearch=teacherId:'+teacherPara?.teacherId" :can-edit="1" :can-delete="1" :link-prop-name="''" /> -->

    </div>

</template>

<script>
const moment = require('moment')
export default {
    props: {
        teacherPara: {}
    },
    data() {
        return {
            vo: {},
            //moduleInfo: {"formTemplate":"dcontent/busiformurl?vwtype=W&url=/teacher/familyMembers/form.html","addNewUrl":"/xsgl/teacherFamilyMembers/addNew","insertUrl":"/xsgl/teacherFamilyMembers/insert","getByIdUrl":"/xsgl/teacherFamilyMembers/getById","updateUrl":"/xsgl/teacherFamilyMembers/update","delUrl":"/xsgl/teacherFamilyMembers/delete","listDataUrl":"/xsgl/teacherFamilyMembers/listdata","winWidth":1000,"winHeight":600,"moduleCode":"familyMembers","openViewType":"0","listAdvSearchAllFields":0,"listAdvSearchExpandPanel":0},
            formTitle: '教师家庭成员信息表',
            form: {
                relationship: '',
                familyMemberName: '',
                birthDate: '',
                familyIdCard: '',
                politicalStatus: '',
                workUnitAndPosition: ''
            },
            dialogFormVisible: false
            //showView: 'listpage',
        }
    },
    computed: {},
    // watch: {
    //     $route: function(a,b){
    //     	this.setShowView()
    //     }
    // },
    created: function() {
        // let formurl = this.moduleInfo.formTemplate.split("url=")[1]
        // formurl = formurl.replace(/\//g,".")
        // formurl = "#/dcontent/vuebusiform/W/"+formurl.substring(1).replace(".html",".vue")
        // formurl += "?sysCode="+(this.$route.meta.sysCode||"")
        // this.$options.components['BusiForm'] = this.$loadComponent(formurl)
    },
    mounted: function() {
    },
    beforeDestroy() {
        localStorage.removeItem('teacherInfos')
    },
    methods: {
        onInnerTableListDataBeforeLoad($scope, qparams) {
            //qparams.urlsearch = `teacher.familyMembers.list?urlsearch=teacherId:${this.teacherPara.teacherId}`
            qparams.urlsearch = `teacherId:${this.teacherPara?.teacherId}`
        },
        /**
              * 表单打开检查，vo为已加载familyMembers对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
              */
        onBasicFormBeforeOpen: function($scope, vo, defer) {
            if (process.env.NODE_ENV === 'development') console.log('familyMembers form before open')
            			defer.resolve(true)
        },
        /**
               * 表单打开完成，vo为已加载的familyMembers对象，前端页面dom对象已完成初始化、已经呈现，不需要返回值
              */
        onBasicFormOpened: function($scope, vo) {
            //if (process.env.NODE_ENV === 'development')
            console.log('familyMembers form opened', this.teacherPara)
        },
        /**
               * 表单提交事件，可执行业务数据高级校验，vo为待提交的familyMembers对象，校验成功：defer.resolve(true)，校验失败：defer.reject(reason)
               */
        onBasicFormBeforeSubmit: function($scope, vo, defer) {
            /*this.$confirm('您是否确认提交保存?', '确认操作', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  })
                      .then(() => {
                          defer.resolve(true)
                      })
                      .catch(err => {
                          defer.reject(err)
                      })*/
            let _this = this
            console.log('localStorage.getItem(teacherInfos)', localStorage.getItem('teacherInfos'))
            if (localStorage.getItem('teacherInfos')) {
                let info = JSON.parse(localStorage.getItem('teacherInfos'))
                vo.teacherBasicInfoId = info?.id
                vo.teacherId = info?.teacherId
                vo.teacherName = info?.name
            }
            vo.familyBirthDate = vo.familyBirthDate ? moment(vo.familyBirthDate).format('YYYY-MM-DD') : ''
            // if(_this.teacherPara?.id){
            //     vo.teacherBasicInfoId = vo.teacherBasicInfoId?vo.teacherBasicInfoId:_this.teacherPara?.id;
            //     vo.teacherId= vo.teacherId?vo.teacherId:_this.teacherPara?.teacherId;
            //     vo.teacherName= vo.teacherName?vo.teacherName: _this.teacherPara?.name;
            // }else{
            //     vo.teacherBasicInfoId = _this.teacherPara?.id;
            //     vo.teacherId=_this.teacherPara?.teacherId;
            //     vo.teacherName= _this.teacherPara?.name;
            // }
            //if (process.env.NODE_ENV === 'development')
            console.log('familyMembers form submit validation success familyBirthDate', _this.teacherPara)
            console.log('familyMembers form submit validation success', _this.vo)
            			defer.resolve(true)
        },
        /**
            * 表单提交完成，vo为已保存成功的familyMembers对象，窗口即将关闭，不需要返回值
            */
        onBasicFormSubmited: function($scope, vo) {
            localStorage.removeItem('teacherInfos')
            //if (process.env.NODE_ENV === 'development')
            console.log('familyMembers form submited', this.vo)
        },
        handleSubmit() {
            //this.vo.teacherId = 1;
            //let data = {
            // ...this.vo,
            //id:this.vo.id?this.vo.id:null,
            //teacherBasicInfoId: this.teacherPara.teacherBasicInfoId,
            //teacherId: this.teacherPara.teacherId,
            //teacherName: this.teacherPara.name,
            //familyBirthdate: this.vo.familyBirthdate?moment(this.vo.familyBirthdate).format('YYYY-MM-DD'):'',
            //relationship: this.vo.name,
            //familyMemberName: this.vo.name,
            //familyIdCard: this.teacherPara.name,
            //politicalStatus: this.vo.politicalStatus,
            //workUnitAndPosition: this.vo.workUnitAndPosition,
            //}
            let _this = this
            if (_this.vo.id) {
                _this.$bus.emit('refreshFamilyMembersList')
                _this.$http({
                    	method: 'put',
                    	url: '/xsgl/teacherFamilyMembers/update',
                    	data: _this.vo
                }).then(res => {
                    	if (res.code === 'success') {
                    		_this.$message.success(res.message)
                    	} else {
                    		_this.$message.error(res.message)
                    	}
                    _this.dialogFormVisible = false
                    _this.form = {}
                    _this.$bus.emit('refreshListData')
                })
            } else {
                let data = {
                    ..._this.vo,
                    //id:this.vo.id?this.vo.id:null,
                    teacherBasicInfoId: _this.teacherPara?.id,
                    teacherId: _this.teacherPara?.teacherId,
                    teacherName: _this.teacherPara?.name
                    //familyBirthdate: this.vo.familyBirthdate?moment(this.vo.familyBirthdate).format('YYYY-MM-DD'):'',
                    //relationship: this.vo.name,
                    //familyMemberName: this.vo.name,
                    //familyIdCard: this.teacherPara.name,
                    //politicalStatus: this.vo.politicalStatus,
                    //workUnitAndPosition: this.vo.workUnitAndPosition,
                }
                _this.$http({
                    	method: 'post',
                    	url: '/xsgl/teacherFamilyMembers/insert',
                    	data: data
                }).then(res => {
                    	if (res.code === 'success') {
                    		_this.$message.success(res.message)
                    	} else {
                    		_this.$message.error(res.message)
                    	}
                    _this.dialogFormVisible = false
                    _this.form = {}
                    _this.$bus.emit('refreshListData')
                })
            }
        },
        // 内嵌子表-表头按钮方法
        selectGroup(val) {
            let _this = this
            console.log('val', val)
            if (val) {
                _this.vo = {...val}
            } else {

            }
            //this.dialogFormVisible = true;
            // _this.moduleInfo.formTemplate = "dcontent/busiformurl?vwtype=W&url=/teacher/familyMembers/form.html"
            // _this.moduleInfo.delUrl = "/xsgl/teacher/familyMembers/delete"
            // _this.moduleInfo.addNewUrl = "/xsgl/teacherFamilyMembers/addNew"
            // _this.moduleInfo.insertUrl = "/xsgl/teacherFamilyMembers/insert"
            // _this.moduleInfo.moduleCode = "ecyoa"
            // _this.moduleInfo.updateUrl = "/xsgl/teacherFamilyMembers/update"

            // let formurl = _this.moduleInfo.formTemplate.split("url=")[1]
            // formurl = formurl.replace(/\//g, ".")
            // formurl = "#/dcontent/vuebusiform/W/" + formurl.substring(1).replace(".html", ".vue")
            // formurl += "?sysCode=" + (this.$route.meta.sysCode || "")
            // _this.$options.components['BusiForm'] = this.$loadComponent(formurl)
            // _this.showView="mainform";
            // _this.$emit('closeShow',1);
            _this.$nextTick(function() {
                _this.$bus.emit('openBusiform', _this.moduleInfo, null, 1)
            })
        },
        onInnerFormBeforeOpen($scope, vo, defer) {
            console.log($scope.moduleInfo.moduleCode, 'onInnerFormBeforeOpen')
        }
    }
}
</script>

<style scoped>
    .header {
        padding: 6px 20px;
        background-color: #f2f5fb;
        font-size: 15px;
        font-weight: 500;
        line-height: 40px;
        display: flex;
        justify-content: space-between;
    }
</style>
